import { BenefitDefinition } from "../../../benefits/benefit.types";
import * as sharedCellSpecs from "../cellSpecs/common";

/**
 * The carrier's name for a quoted plan, which the marketing presentation prints
 * as its "Plan Name" row. It lives on the plan itself (`name`), not in the
 * benefits body, so the row is keyed `name` and reads and writes it at plan
 * level.
 *
 * `mpOnly` keeps it out of the Build tab: the RFP's own benefit plans have no
 * name field, so only quote columns can hold one.
 */
export const planNameRow: BenefitDefinition = {
  label: "Plan Name",
  mpConfigKey: "plan_name",
  mpOnly: true,
  benefitPlanLevel: true,
  cell: sharedCellSpecs.text,
};
